import { ICartState } from './index';
import IAction from 'config/redux/actions/interface';

export const updateCartLoyaltyPoints = (state: ICartState, action: IAction<number>) => {
  const { payload } = action;
  return { ...state, loyaltyPoints: payload };
};
